function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.363 18.54l-.79.814a5.463 5.463 0 01-7.896 0c-2.18-2.25-2.18-5.897 0-8.146L4.56 9.265a5.043 5.043 0 017.289 0l.304.313M10.72 3.543l.79-.815a5.463 5.463 0 017.896 0c2.18 2.25 2.18 5.897 0 8.146l-1.883 1.943a5.043 5.043 0 01-7.289 0l-.304-.313",
  stroke: "currentColor",
  strokeWidth: 2.083,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgLinkReferal = function SvgLinkReferal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none"
  }, props), _ref);
};

export default SvgLinkReferal;